export default __webpack_public_path__ + "static/media/Shoes1.45149351.png";